import type { TRuleWithTheme } from '@/styles/theme';

export const container: TRuleWithTheme = ({ theme }) => ({
    paddingTop: theme.spacing(28),
    paddingBottom: theme.spacing(24),
    paddingInline: theme.spacing(24),
    borderRadius: 4,
    backgroundColor: theme.colors.white,
    position: 'relative',
    zIndex: 1,
    min768: {
        width: 520,
    },
    max768: {
        width: '100%',
    },
});

export const title: TRuleWithTheme = ({ theme }) => ({
    marginBottom: theme.spacing(16),
    color: `${theme.colors.black} !important`,
});

export const description: TRuleWithTheme = ({ theme }) => ({
    marginBottom: theme.spacing(32),
    color: theme.colors.foregroundsTertiary,
});

export const footer: TRuleWithTheme = ({ theme }) => ({
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: theme.spacing(16),
});
